<div
    class="flex items-center justify-between cursor-pointer bg-gray-100 px-3 py-2 rounded w-full overflow-hidden"
    (click)="toggleFold()"
>
    <strong class="text-gray-700">Customization:</strong>
    <fa-icon *ngIf="showHeader"
        [icon]="folded ? 'plus' : 'minus'"
        class="text-gray-600"
    ></fa-icon>
</div>

<div
    [class.hidden]="folded"
    class="bg-white border border-t-0 border-gray-200 px-3 py-2 space-y-2 w-full overflow-hidden"
>
    <div *ngIf="optionName" class="flex items-center justify-between">
        {{optionName}}
    </div>
    <!-- Single ordered list: messages / paid options / text-frame groups render
         in the configured customization-option order (standalone overlays are
         no longer forced to the bottom). Text-frame groups surface the owning
         ImageFrame name inline via displayLabel for nested overlays. -->
    <div *ngIf="rows.length" class="space-y-1">
        <ng-container *ngFor="let row of rows">
            <div *ngIf="row.kind === 'item'" [ngSwitch]="row.item.kind">
                <!-- Image -->
                <div *ngSwitchCase="'image'" class="relative group block md:line-clamp-1 md:overflow-hidden">
                    <p class="break-words" [title]="row.item.value">
                        <span class="block sm:inline font-medium text-gray-600">
                            {{ row.item.label }}:
                        </span>
                        <span class="block sm:inline sm:whitespace-pre-wrap text-gray-800">
                            {{ row.item.value }}
                        </span>
                    </p>
                </div>
                <!-- Message -->
                <div *ngSwitchCase="'message'" class="relative group">
                    <p class="text-sm text-gray-600 md:line-clamp-3 md:overflow-hidden whitespace-pre-wrap"
                       [title]="row.item.value">
                        <strong>{{ row.item.label }}</strong>
                        <strong *ngIf="row.item.required">*</strong>
                        : {{ row.item.value }}
                    </p>
                </div>
                <!-- Paid Option -->
                <div *ngSwitchCase="'paid-option'" class="flex justify-between items-center">
                    <p class="text-sm text-gray-600 truncate" [title]="row.item.value">
                        <strong>{{ row.item.label }}</strong>
                        <strong *ngIf="row.item.required">*</strong>
                        <span class="block sm:inline sm:whitespace-pre-wrap text-gray-800 ">
                            : {{ row.item.value }}
                        </span>
                    </p>
                    <span *ngIf="row.item.amount" class="text-sm font-semibold text-[#2E3742] whitespace-nowrap">
                        + {{ row.item.amount | formatPrice }}
                    </span>
                </div>
            </div>
            <!-- Text frame group -->
            <div *ngIf="row.kind === 'group'" class="space-y-1">
                <p class="text-sm text-gray-500">
                    <strong>{{ row.group.displayLabel }}</strong>
                </p>
                <div class="pl-3">
                    <p class="text-sm text-gray-600">
                        <strong>Font</strong>: {{ row.group.fontFamily }}
                    </p>
                </div>
                <div class="pl-3">
                    <p class="text-sm text-gray-600">
                        <strong>Text Color</strong>: {{ row.group.colorName }}
                    </p>
                </div>
                <div *ngFor="let f of row.group.frames" class="relative group pl-3">
                    <p class="text-sm text-gray-600 md:line-clamp-3 md:overflow-hidden whitespace-pre-wrap"
                        [title]="f.content">
                        <strong>{{ f.name }}</strong>: {{ f.content }}
                    </p>
                </div>
            </div>
        </ng-container>
    </div>
    <!-- total add-on footer -->
    <div *ngIf="totalAddOn" class="flex justify-between items-center pt-1 border-t border-dashed">
        <span class="text-sm font-medium">Add-ons total</span>
        <span class="text-sm font-bold text-[#2E3742]">
            {{ totalAddOn | formatPrice }}
        </span>
    </div>
</div>
